/**
 * Created by sidchik on 16.10.14.
 */

//window.fbAsyncInit = function() {
//    FB.init({
//        appId      : '865009010178606',
//        xfbml      : false,
//        version    : 'v2.3'
//    });
//};


function setSocialButtonFB($modal, postData)
{

}

function socialPostFB(postData)
{
  Share.fb(postData);


  //var url  = 'https://www.facebook.com/dialog/feed?';
  //url += '&app_id=865009010178606';
  //url += '&display=page';
  //url += '&link=' + encodeURIComponent(postData.url);
  //url += '&redirect_uri=' + encodeURIComponent(postData.url);
  //url += '&title='       + encodeURIComponent(postData.title);
  //url += '&picture=' + encodeURIComponent(postData.image);
  //url += '&description=' + encodeURIComponent(postData.description);
  //window.location = url;

}